import { GeneralKeywordsApi } from 'api/general-keywords';
import { IMapZoneInfoDTO } from 'api/swagger/ApiClient';
import { EventAggregator } from 'aurelia-event-aggregator';
import { autoinject } from 'aurelia-framework';
import { tryExecute } from 'framework/error_handling/error-utils';
import { BusinessFormType, DeviationTeamType } from 'model/business-enums';
import { AccommodationType, Airline, ApprovalLevel, Country, DeviationTeam, OrganisationEntity, Site, TransportType, TravelType } from 'model/business-keywords';
import { EntityBase } from 'model/platform-types';
import { ServiceBase } from 'support/base_classes/service-base';
import * as E from 'support/errors';
import { IdentityService } from './identity-service';

@autoinject
export class KeywordsService extends ServiceBase {
  transportTypes: TransportType[] = [];
  accommodationTypes: AccommodationType[] = [];
  countries: Country[] = [];
  airlines: Airline[] = [];
  approvalLevels: ApprovalLevel[] = [];
  organisationEntities: OrganisationEntity[] = [];
  travelTypes: TravelType[] = [];
  deviationTeams: DeviationTeam[] = [];
  mapZones: IMapZoneInfoDTO[] = [];
  sites: Site[] = [];

  constructor(private api: GeneralKeywordsApi, private ea: EventAggregator, private identity: IdentityService) {
    super();
  }

  protected async initializeService() {
    await this.reload();
    this.sites = this.identity.roles.isAdmin ? await this.api.getSites(this.countries) : [];
    this.ea.subscribe('settings-changed', () => this.refresh());
    setInterval(() => this.refresh(), 120000);
  }

  private refresh() {
    return tryExecute(() => this.reload(), E.SERVICE_RELOAD_MESSAGE, E.SERVICE_RELOAD_TITLE, true);
  }

  async reload() {
    [this.transportTypes, this.accommodationTypes, this.countries, this.airlines, this.approvalLevels, this.organisationEntities, this.travelTypes, this.deviationTeams, this.mapZones] = await Promise.all(
      [this.api.getTransportTypes(), this.api.getAccommodationTypes(), this.api.getCountries(), this.api.getAirlines(), this.api.getApprovalLevels(), this.api.getOrganisationEntities(), this.api.getTravelTypes(), this.api.getDeviationTeams(), this.identity.roles.isAdmin ? this.api.getMapZones() : []]
    );
  }

  getAccommodationTypes(formType: BusinessFormType) {
    return this.accommodationTypes.filter(k =>
      formType === BusinessFormType.HolidayTrip && k.isForHolidayTrip ||
      formType === BusinessFormType.TravelRequest && k.isForTravelRequest
    );
  }

  getDeviationTeam(deviationTeamType: DeviationTeamType): DeviationTeam {
    return this.deviationTeams.filter(x => x.teamType.value === deviationTeamType)[0];
  }

  ensureItem<T extends EntityBase>(list: T[], item: T, replace = false) {
    return item == null ? list : !list.some(i => this.itemsMatch(i, item)) ? [...list, item] : list.map(i => this.itemsMatch(i, item) && !replace ? item : i);
  }

  itemsMatch(x: EntityBase, y: EntityBase) {
    if (x == null && y == null) return true;
    if (x == null || y == null) return false;
    return x === y || x.id === y.id;
  }
}
